import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { customersUrl, downloadCustomerCsvUrl, getCustomerDetailUrl, paymentsUrl } from '../../shared/helpers/endPoints';
import { CREATE_CUSTOMER, DOWNLOAD_CUSTOMER_CSV, GET_CUSTOMERS, GET_CUSTOMER_DETAILS, GET_CUSTOMER_TRANSACTION, UPDATE_CUSTOMER_DETAILS } from './actionTypes';
import { fetchJSON } from '../../shared/helpers/apiCalls';
import { setCustomers, setCustomerDetials, getCustomers, downloadCustomerCsvSuccess, downloadCustomerCsvFailure, setCustomerTransaction, getCustomerTransactionFailure } from './action';
import { setError, setModal, setSuccess, setProcessLoading } from '../utils/action';
import { getStoreLocal } from '../../shared/helpers/utils';
import { authService } from '../../modules/users/services/dependency.injection';
import { toast } from 'react-toastify';

function* callGetCustomerDetails({ payload: customerId }) {
    const access_token = authService.accessToken();
    const modeType = getStoreLocal('modeType');

    try {
        const options = {
            method: 'GET',
            url: getCustomerDetailUrl(modeType, customerId),
            headers: {
                Authorization: `Bearer ${access_token}`
            }
        };

        const response = yield call(fetchJSON, options);
        yield put(setCustomerDetials(response.data));
    } catch (error) {
        // let message = error === undefined ? 'Something went wrong please try again later' : error.data.error.message;
    }
}

function* callCreateCustomer({ payload: values }) {
    const access_token = authService.accessToken();
    const modeType = getStoreLocal('modeType');

    try {
        const options = {
            method: 'POST',
            url: customersUrl(modeType),
            headers: {
                Authorization: `Bearer ${access_token}`,
                'Content-Type': 'application/json'
            },
            data: JSON.stringify(values)
        };

        yield call(fetchJSON, options);

        yield put(setSuccess('You have successfully added a customer'));
        // call the get endpoint again to fetch updated customer list
        yield put(getCustomers({ merchantId: values.merchantId, offset: 0, limit: 10 }));
        yield put(setModal({ addCustomerModal: false }));
        yield put(setError(''));
    } catch (error) {
        let message = error === undefined ? 'Something went wrong please try again later' : error.data.error.message;
        yield put(setError(message));
    }
}

function* callGetCustomers({ payload: values }) {
    const access_token = authService.accessToken();
    const modeType = getStoreLocal('modeType');

    try {
        const options = {
            method: 'GET',
            url: customersUrl(modeType),
            headers: {
                Authorization: `Bearer ${access_token}`
            },
            params: { ...values }
        };

        const response = yield call(fetchJSON, options);
        yield put(setCustomers(response.data));
    } catch (error) {
        // let message = error === undefined ? 'Something went wrong please try again later' : error.data.error.message;
    }
}

function* callUpdateCustomer({ payload: values }) {
    const access_token = authService.accessToken();
    const modeType = getStoreLocal('modeType');

    try {
        const options = {
            method: 'POST',
            url: customersUrl(modeType),
            headers: {
                Authorization: `Bearer ${access_token}`,
                'Content-Type': 'application/json'
            },
            data: JSON.stringify(values)
        };

        const response = yield call(fetchJSON, options);

        yield put(setSuccess('You have successfully updated customer detail'));
        yield put(setCustomerDetials(response.data));
        yield put(setProcessLoading(false));
        yield put(setModal({ updateCustomerModal: false }));
    } catch (error) {
        let message = error === undefined ? 'Something went wrong please try again later' : error.data.error.message;
        yield put(setError(message));
        yield put(setProcessLoading(false));
    }
}

function* downloadCsvForCustomer({payload: values}) {
    const access_token = authService.accessToken();
    const modeType = getStoreLocal('modeType');

    try {
        const options = {
            method: 'GET',
            url: downloadCustomerCsvUrl(modeType, values),
            headers: {
                Authorization: `Bearer ${access_token}`,
                'Content-Type': 'application/json'
            }
        };

        const response = yield call(fetchJSON, options);
        const blob = new Blob([response.data], { type: "text/csv" });
        const blobUrl = window.URL.createObjectURL(blob)
        const tempLink = document.createElement("a");
        tempLink.style.display = "none";
        tempLink.href = blobUrl
        tempLink.download = "customer.csv"
        tempLink.setAttribute("target", "_blank");
        document.body.appendChild(tempLink);
        tempLink.click()
        document.body.removeChild(tempLink);
        window.URL.revokeObjectURL(blobUrl)

        yield put(downloadCustomerCsvSuccess('You have successfully downloaded the csv'));
    } catch (error) {
        let message = error === undefined ? 'Something went wrong please try again later' : error.data.error.message;
        yield put(downloadCustomerCsvFailure(message))
    }
}

function* getCustomerTransaction({payload: value}) {
    const access_token = authService.accessToken();
    const modeType = getStoreLocal('modeType');
    
    try {
        const options = {
            method: 'GET',
            url: paymentsUrl(modeType),
            headers: {
                Authorization: `Bearer ${access_token}`
            },
            params: value
        };

        const response = yield call(fetchJSON, options)
        yield put(setCustomerTransaction(response.data))
    } catch(error){
        let message = error?.data?.error?.message === undefined ? 'Something went wrong please try again later' : error?.data?.error?.message;
        toast.error(message)
        yield put(getCustomerTransactionFailure("it failed"))
    }
}

export function* watchCallGetCustomerDetails() {
    yield takeEvery(GET_CUSTOMER_DETAILS, callGetCustomerDetails);
}

export function* watchCallCreateCustomer() {
    yield takeEvery(CREATE_CUSTOMER, callCreateCustomer);
}
export function* watchCallGetCustomers() {
    yield takeEvery(GET_CUSTOMERS, callGetCustomers);
}
export function* watchCallUpdateCustomer() {
    yield takeEvery(UPDATE_CUSTOMER_DETAILS, callUpdateCustomer);
}
export function* watchCallDownloadCustomerCsv() {
    yield takeEvery(DOWNLOAD_CUSTOMER_CSV, downloadCsvForCustomer);
}
export function* watchCallGetCustomerTransaction() {
    yield takeEvery(GET_CUSTOMER_TRANSACTION, getCustomerTransaction)
}
function* customersSaga() {
    yield all([
        fork(watchCallGetCustomers),
        fork(watchCallCreateCustomer),
        fork(watchCallGetCustomerDetails),
        fork(watchCallUpdateCustomer),
        fork(watchCallDownloadCustomerCsv),
        fork(watchCallGetCustomerTransaction)
    ]);
}
export default customersSaga;
